export const menuItems = [
    {
        id: 1,
        label: "menuitems.menu.text",
        isTitle: true
    },
    {
        id: 2,
        label: "menuitems.dashboard.text",
        link: "/",
        icon: "bx-home-circle",
    },

      


    {
        id: 15,
        label: "menuitems.fuels.text",
        link: "/fuels",
        icon: "bx-filter-alt",
    },    
  

    // {
    //     id: 6,
    //     label: "menuitems.trucks.text",
    //     link: "",
    //     icon: "bxs-truck",

    //     subItems: [
    //         {
    //             id: 7,
    //             label: "menuitems.trucks.list.pending",
    //             link: "/pending-trucks",
    //             parentId: 6
    //         },
    //         {
    //             id: 8,
    //             label: "menuitems.trucks.list.approved",
    //             link: "/trucks",
    //             parentId: 6
    //         },
    //     ]
    // },

    {
        id: 6,
        label: "menuitems.trucks.text",
        link: "/trucks",
        icon: "bxs-truck",
    },    
    

    {
        id: 9,
        label: "menuitems.drivers.text",
        link: "",
        icon: "bx-user-circle",
        
        subItems: [
            {
                id: 10,
                label: "menuitems.drivers.list.pending",
                link: "/pending-drivers",
                parentId: 9
            },
            {
                id: 11,
                label: "menuitems.drivers.list.approved",
                link: "/drivers",
                parentId: 9
            },
           
        ]
    },

    {
        id: 12,
        label: "menuitems.orders.text",
        link: "/orders",
        icon: "bx-cart",
    },

    {
        id: 13,
        label: "menuitems.payments.text",
        link: "/payment-logs",
        icon: "bx-money",
    },

 
    {
        id: 30,
        label: "menuitems.reports.text",
        link: "",
        icon: "bx-file",
        
        subItems: [
            {
                id: 31,
                label: "menuitems.reports.list.sales",
                link: "/reports/sales",
                parentId: 30
            },
            {
                id: 32,
                label: "menuitems.reports.list.earnings",
                link: "/reports/earnings",
                parentId: 30
            },

            {
                id: 33,
                label: "menuitems.reports.list.commissions",
                link: "/reports/commissions",
                parentId: 30
            },
           
        ]
    },

    {
        id: 16,
        label: "menuitems.notifications.text",
        link: "/notifications",
        icon: "bx-bell",
    },
    {
        id: 34,
        label: "menuitems.broadcasts.text",
        link: "/broadcasts",
        icon: "bx-broadcast",
    },


    {
        id: 18,
        label: "menuitems.ratings.text",
        link: "",
        icon: "bx-star",
        
        subItems: [
            {
                id: 19,
                label: "menuitems.ratings.list.customers",
                link: "/ratings/customers",
                parentId: 18
            },
            {
                id: 20,
                label: "menuitems.ratings.list.drivers",
                link: "/ratings/drivers",
                parentId: 18
            },
           
        ]
    },

    {
        id: 5,
        label: "menuitems.profile.text",
        link: "/profile",
        icon: "bx-gas-pump",
    },
    
];

